import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";

const socialItems = [
  {
    icon: <FaFacebookF className="text-xl" />,
    url: "https://www.facebook.com/people/VGL-Trans-Express/100090467929029/?locale=ro_RO&_rdr",
    bg: "bg-gradient-to-br from-blue-600 to-purple-600",
  },
  {
    icon: <FaInstagram className="text-xl" />,
    url: "https://www.instagram.com/vgl.trans.express/",
    bg: "bg-gradient-to-br from-pink-500 to-yellow-500",
  },
  {
    icon: <FaTiktok className="text-xl" />,
    url: "https://www.tiktok.com/@vgl.trans.express",
    bg: "bg-black",
  },
];

const SocialLinks = () => {
  return (
    <div className="flex space-x-4">
      {socialItems.map((item, index) => (
        <a
          key={index}
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`w-10 h-10 ${item.bg} rounded-lg flex items-center justify-center text-white hover:scale-110 transition-transform duration-300`}
        >
          {item.icon}
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
